import React from "react";
import { formatSavedAddress } from "../../utils/siteUtils";
import classNames from "classnames";
import "./style.scss";
const AddressInformation = ({ address, className, marketCountry, countryPrivateImportMessage, showCountry = true }) => {
  if (address) {
    const contents = formatSavedAddress(address, showCountry);
    const rootClassNames = classNames("address-information", className);
    return (
      <div className={rootClassNames}>
        {contents.map((row, index) => (
          <p className="content-row" key={index}>
            {row}
          </p>
        ))}
        {marketCountry && marketCountry.regionAbbr !== address.countryCode && countryPrivateImportMessage && <p className="content-row">{countryPrivateImportMessage.value}</p>}
      </div>
    );
  } else {
    return null;
  }
};
export default AddressInformation;
